import {useGetData} from '../../src/apiservice/apiCall'


export function useCrest(){
	return useGetData('/api/WebApi/GetCrest')
}
